// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Actions
import { setFundChartTitle } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/title/title.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const title = createReducer('', on(setChartData, (state, { chartData }) => chartData.params.title), on(setFundChartTitle, (state, action) => action.title));
